import { createContext } from 'react'

export const SociogramStateContext = createContext()
export const SociogramActionsContext = createContext()
